<script>
  import { scale } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
</script>

<section in:scale="{{delay: 250, duration: 300, easing: quintOut }}" out:scale="{{delay: 250, duration: 300, easing: quintOut }}" >
    Plan
</section>

<style lang="postcss">

</style>